import ActiveController from "rapid/controller";

export class htmlCustomBtnPreviewController extends ActiveController {
  constructor($injector, $rootScope, $element, $scope, $timeout) {
    "ngInject";
    super($injector);

    this.$rootScope = $rootScope;
    this.$element = angular.element($element);
    this.$scope = $scope;
    this.width = 0;
    this.height = 0;
    this.renderedArray = [];
    this.uniqueId = `id-${Math.random()}`;
    this.bgId = `bg-${Math.random()}`;
    this.overlayId = `overlay-${Math.random()}`;
    this.boomerangId = `boomerang-${Math.random()}`;
    this.$timeout = $timeout;
    this.boomerangCount = null;
    this.outputHeight = 0;

    $scope.$watch(
      () => this.areas,
      () => {
        let divider = Number(this.index);
        try {
          this.areas = JSON.parse(this.areas);
          this.renderedArray = [];
          this.areas &&
          Object.keys(this.areas).forEach((area) => {
            if (
                (!this.areas[area].x && this.areas[area].x !== 0) ||
                (!this.areas[area].y && this.areas[area].y !== 0)
              ) {
                return false;
              }
              let el = {};
              // Basic values
              if (!this.relatedValues) {
                el = {
                  x: Math.round(this.areas[area].x / divider) + "px",
                  y: Math.round(this.areas[area].y / divider) + "px",
                  width: this.areas[area].width
                    ? Math.round(this.areas[area].width / divider) + "px"
                    : 0,
                  height: this.areas[area].height
                    ? Math.round(this.areas[area].height / divider) + "px"
                    : 0,
                };
              } else {
                el = {
                  x: this.areas[area].x,
                  y: this.areas[area].y,
                  width:
                    ((((this.areas[area].width*1.4) / 100) * this.prHeight) /
                      this.prWidth) *
                    100,
                  height: this.areas[area].height*1.4,
                };

                if (area === "scene"){
                  el.y -= 120 /((Number(this.height.replace("px",""))) /100);
                  el.x -= 95 / ((Number(this.width.replace("px",""))) / 100);
                  el.width = "95px";
                  el.height = "120px";
                } else{
                  el.x -= el.width / 2;
                  el.y -= el.height / 2;
                  el.width += "%";
                  el.height += "%";
                }
                el.x += "%";
                el.y += "%";
              }
              // Gif background
              switch (area) {
                case "back":
                  el.back = require("../../../../images/icons/back-btn-icon.svg");
                  break;
                case "sharingBackBtn":
                  el.sharingBackBtn = require("../../../../images/icons/back-btn-icon.svg");
                  break;
                case "filter":
                  el.filter = require("../../../../images/icons/effects-btn-icon.svg");
                  break;
                case "capture":
                  el.capture = require("../../../../images/icons/shoot-btn-icon.svg");
                  break;
                case "proceed":
                  el.proceed = require("../../../../images/icons/shoot-btn-icon.svg");
                  break;
                case "single":
                  el.single = require("../../../../images/icons/photo-icon.svg");
                  break;
                case "gif":
                  el.gif = require("../../../../images/icons/gif-icon.svg");
                  break;
                case "boomerang":
                  el.boomerang = require("../../../../images/icons/boomerang-icon.svg");
                  break;
                case "email":
                  el.email = require("../../../../images/icons/email-btn-icon.svg");
                  break;
                case "sms":
                  el.sms = require("../../../../images/icons/sms-btn-icon.svg");
                  break;
                case "print":
                  el.print = require("../../../../images/icons/print-btn-icon.svg");
                  break;
                case "done":
                  el.done = require("../../../../images/icons/done-btn-icon.svg");
                  break;
                case "qrCode":
                  el.qrCode = require("../../../../images/icons/qr-btn-icon.svg");
                  break;
                case "scene":
                  el.scene = require("../../../../images/icons/popup-icon.svg");
                  el.scenePopupColor = this.areas[area].scenePopupColor;
                  break;
              }
              // Image background
              if (this.areas[area].image) {
                if (this.single) {
                  el.image = require("../../../../images/photo.png");
                } else if (!this.areas[area].title) {
                  el.image = require("../../../../images/1.png");
                } else {
                  if (this.boomerang) {
                    el.image = require(`../../../../images/boomerang-frames/b${
                      this.areas[area].title[0] * 30
                    }.png`);
                  } else {
                    el.image = require(`../../../../images/${this.areas[area].title[0]}.png`);
                  }

                  let mainSide =
                    this.areas[area].height < this.areas[area].width
                      ? "height"
                      : "width";
                  el.title = this.areas[area].title;
                  el.font =
                    Math.round((this.areas[area][mainSide] / divider) * 0.55) +
                    "px";
                }
              } else if (this.areas[area].gif) {
                this.drawGif([1, 2, 3]);
                el.frames = true;
              } else if (this.areas[area].video) {
                el.video = true;
              }
              el.angle = this.areas[area].angle + "deg";
              if (
                this.areas[area].customIcon &&
                this.areas[area].customIcon.attachment_file
              ) {
                el.customIcon = {
                  attachment_file: this.areas[area].customIcon.attachment_file,
                };
              }

              this.renderedArray.push(el);
              if (el.video) {
                this.$timeout(() => {
                  this.makeBoomerang();
                });
              }
            });
        } catch (e) {
          //
        }
      }
    );

    $scope.$watch(
      () => this.prWidth,
      () => {
        this.changeSize();
      }
    );

    $scope.$watch(
      () => this.prHeight,
      () => {
        this.changeSize();
      }
    );

    $scope.$watch(
      () => this.index,
      () => {
        this.changeSize();
      }
    );

    $scope.$watch(
      () => this.videoTime,
      () => {
        this.makeBoomerang();
      }
    );

    $scope.$watch(
      () => this.videoSpeed,
      () => {
        this.makeBoomerang();
      }
    );

    $scope.$watch(
      () => this.background,
      () => {
        this.animateBackground();
      }
    );

    $scope.$watch(
      () => this.overlay,
      () => {
        this.animateOverlay();
      }
    );
    $scope.$watch(
      () => this.animationSpeed,
      () => {
        this.animateOverlay();
        this.animateBackground();
      }
    );

    $scope.$watch(
        () => this.videoOverlay
    );
  }

  $onInit() {
    this.changeSize();
    this.liveViewVideo = require(`../../../../images/short-preview.mp4`);
  }

  $onDestroy() {
    clearInterval(this.count);
    clearInterval(this.countBackground);
    clearInterval(this.countOverlay);
    clearInterval(this.boomerangCount);
  }

  changeSize() {
    this.width = Math.round(Number(this.prWidth) / Number(this.index)) + "px";
    this.height = Math.round(Number(this.prHeight) / Number(this.index)) + "px";
    if (Number(this.prWidth) > Number(this.prHeight)) {
      this.bleed = {
        width: 1800 / Number(this.index) + "px",
        height: 1200 / Number(this.index) + "px",
        top: 22 / Number(this.index) + "px",
        left: 20 / Number(this.index) + "px",
      };
    } else {
      this.bleed = {
        width: 1200 / Number(this.index) + "px",
        height: 1800 / Number(this.index) + "px",
        top: 20 / Number(this.index) + "px",
        left: 22 / Number(this.index) + "px",
      };
    }

    this.orientation = this.width > this.height ? "landscape" : "portrait";

    this.captureSize = Math.round(Number(this.width > this.height ? this.prHeight : this.prWidth)/Number(this.index)) - 60;
    this.captureheight = Math.round(Number(this.width < this.height ? this.prHeight : this.prWidth)/Number(this.index)) - 60;

    this.outputHeight = this.orientation !== "portrait"
        ? (this.captureSize - this.captureheight / 6)
        : (this.captureheight - this.captureheight / 4);
  }

  drawGif(frames) {
    clearInterval(this.count);
    let idx = 0;
    this.gifFrame = require(`../../../../images/${frames[idx]}.png`);

    this.count = setInterval(
      () => {
        this.gifFrame = require(`../../../../images/${frames[idx]}.png`);
        this.$scope.$apply(() => this.gifFrame);
        if (idx === frames.length - 1) {
          idx = 0;
        } else {
          idx++;
        }
      },
      this.gifSpeed ? (Number(this.gifSpeed) / frames.length) * 1000 : 667
    );
  }

  makeBoomerang() {
    clearInterval(this.boomerangCount);
    const allFiles = 120;
    const framesPerSecond = 24;
    let time = this.videoTime <= 5 ? this.videoTime || 1.5 : 5; // Added mock for preview to be 5 seconds even if video time is longer (up to 8s);
    let speed = this.videoSpeed || 1.5;
    let startCount = allFiles - time * 24;
    let direction = "forward";
    let idx = 0;
    let speedIndex = (time * 2) / speed;
    let imagesArr = [];
    let loadedImages = 0;

    let onImageLoad = () => {
      loadedImages++;
      clearInterval(this.boomerangCount);
      if (loadedImages === imagesArr.length) {
        clearInterval(this.boomerangCount);
        this.boomerangCount = setInterval(() => {
          this.boomerangFrame = imagesArr[Math.floor(idx)]
            ? imagesArr[Math.floor(idx)].src
            : "";
          this.$scope.$apply(() => this.boomerangFrame);
          if (idx >= imagesArr.length && direction === "forward") {
            direction = "backward";
          } else if (idx <= 0 && direction === "backward") {
            direction = "forward";
          } else {
            direction === "forward" ? (idx += speedIndex) : (idx -= speedIndex);
          }
        }, 1000 / framesPerSecond);
      }
    };

    for (let i = startCount; i <= 120; i++) {
      let img = new Image();
      img.src = require(`../../../../images/boomerang-frames/b${Math.floor(
        i
      )}.png`);
      img.onload = () => {
        onImageLoad();
      };
      imagesArr.push(img);
    }
  }

  animateBackground() {
    setTimeout(() => {
      try {
        let arr;
        try {
          const parsed = JSON.parse(this.background);
          arr = Array.isArray(parsed) ? parsed : (this.background ? [this.background] : []);
        } catch (parseError) {
          arr = this.background ? [this.background] : [];
        }
        let pr = document.getElementById(this.bgId);
        if (!pr) {
          return;
        }
        let images = [];
        for (let i = 0; i < arr.length; i++) {
          let image = new Image();
          image.src = arr[i];
          arr[i] = images.push(image);
        }
        clearInterval(this.countBackground);
        if (arr.length > 1) {
          let idx = 0;
          this.countBackground = setInterval(
            () => {
              pr.style.backgroundImage = `url(${images[idx].src})`;
              if (idx === arr.length - 1) {
                idx = 0;
              } else {
                idx++;
              }
            },
            this.animationSpeed
              ? (Number(this.animationSpeed) / arr.length) * 1000
              : 1000
          );
        } else if (arr.length === 1) {
          const image = images[0];
          const applyBackground = () => {
            pr.style.backgroundImage = `url(${image.src})`;
            this.background = image.src;
          };
          if (image.complete) {
            applyBackground();
          } else {
            image.onload = applyBackground;
          }
        } else {
          pr.style.backgroundImage = "none";
          this.background = null;
        }
      } catch (e) {
        //console.log(e);
      }
    });
  }

  animateOverlay() {
    setTimeout(() => {
      try {
        let arr = JSON.parse(this.overlay);
        let pr = document.getElementById(this.overlayId);
        let images = [];
        for (let i = 0; i < arr.length; i++) {
          let image = new Image();
          image.src = arr[i];
          arr[i] = images.push(image);
        }
        clearInterval(this.countOverlay);
        if (arr.length > 1) {
          let idx = 0;
          this.countOverlay = setInterval(
            () => {
              pr.style.backgroundImage = `url(${images[idx].src})`;
              if (idx === arr.length - 1) {
                idx = 0;
              } else {
                idx++;
              }
            },
            this.animationSpeed
              ? (Number(this.animationSpeed) / arr.length) * 1000
              : 1000
          );
        } else {
          arr.length ? (this.overlay = images[0].src) : (this.overlay = null);
        }
      } catch (e) {
        //console.log(e);
      }
    });
  }

  isVideo(name) {
    if (name === undefined || name === null) {
      return false;
    } else {
      return (
        name.indexOf(".mp4") !== -1 ||
        name.indexOf(".webm") !== -1 ||
        name.indexOf(".mov") !== -1
      );
    }
  }

  shouldShowBackgroundMedia() {
    return this.enabled && (this.mode !== "fullscreen" || this.screen === "output");
  }

  shouldShowImageBackground() {
    return this.shouldShowBackgroundMedia()
      && this.bgMode === "image"
      && this.background
      && this.background !== "[]"
      && !(this.videoBackground && this.isVideo(this.videoBackground));
  }

  shouldShowVideoBackground() {
    return this.shouldShowBackgroundMedia()
      && this.bgMode === "image"
      && this.videoBackground
      && this.isVideo(this.videoBackground);
  }

  setOpacity(tr) {
    if (!this.transparency || !this.transparency.enabled) {
      return 1;
    }
    return tr / 100;
  }
}



// WEBPACK FOOTER //
// ./sources/components/common/html-custom-btn-preview/html-custom-btn-preview.controller.js